import { supabase } from "@/integrations/supabase/client";

export interface UploadedFileData {
  fileUrl: string;
  storagePath: string;
}

/**
 * Uploads a file to Supabase storage and returns a signed URL
 * @param file The file to upload
 * @param folderPath The folder path in storage (e.g., 'temp-uploads', 'documents')
 * @returns Object with fileUrl and storagePath
 */
export async function uploadFileToStorage(
  file: File,
  folderPath: string = "temp-uploads",
): Promise<UploadedFileData> {
  const sanitizedFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
  const storagePath = `${folderPath}/${Date.now()}_${sanitizedFileName}`;

  const { error: uploadError } = await supabase.storage
    .from("agent-documents")
    .upload(storagePath, file);

  if (uploadError) throw uploadError;

  const { data: urlData } = await supabase.storage
    .from("agent-documents")
    .createSignedUrl(storagePath, 60 * 60 * 24 * 7);

  const fileUrl = urlData?.signedUrl;
  if (!fileUrl) throw new Error("Failed to generate signed URL");

  return { fileUrl, storagePath };
}
